/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    string, func, oneOfType, shape, elementType, number,
} from 'prop-types';
import ImageEditor from './ImageEditor/ImageEditor';
import SelectPersonalizeImage from './ImageEditor/SelectPersonalizeImage';

const PersonalizeImageCustoms = ({
    image,  handleImage, imagePreviewCanvasRef, setImage, imgHeight, imgWidth,
}) => (
    <>
        {!image
            ?                    (
                <SelectPersonalizeImage handleImage={handleImage} />
            )
            : (
                <ImageEditor
                    image64={image}
                    setImage={setImage}
                    imgWidth={imgWidth}
                    imgHeight={imgHeight}
                    imagePreviewCanvasRef={imagePreviewCanvasRef}
                />
            )}
    </>
);

PersonalizeImageCustoms.propTypes = {
    image: string.isRequired,
    handleImage: func.isRequired,
    setImage: func.isRequired,
    imagePreviewCanvasRef: oneOfType([
        func,
        shape({ current: elementType }),
    ]).isRequired,
    imgWidth: number.isRequired,
    imgHeight: number.isRequired,
};

export default PersonalizeImageCustoms;
